import { useEffect, useRef, useState, useLayoutEffect } from "react";
import { createPortal } from "react-dom";

import "./style.scss";

const Tooltip = ({ target, content, position = "bottom", style = {}, pt = {} }) => {
    const [visible, setVisible] = useState(false);
    const [coords, setCoords] = useState({ top: -9999, left: -9999 });
    const tooltipRef = useRef(null);
    const currentTargetRef = useRef(null);

    useEffect(() => {
        if (!target) return;

        const show = (e) => {
            currentTargetRef.current = e.currentTarget;
            setVisible(true);
        };

        const hide = () => {
            setVisible(false);
        };

        const elements = document.querySelectorAll(target);
        elements.forEach((el) => {
            el.addEventListener("mouseenter", show);
            el.addEventListener("mouseleave", hide);
        });

        return () => {
            elements.forEach((el) => {
                el.removeEventListener("mouseenter", show);
                el.removeEventListener("mouseleave", hide);
            });
        };
    }, [target]);

    useLayoutEffect(() => {
        if (!visible || !tooltipRef.current || !currentTargetRef.current) return;

        const targetEl = currentTargetRef.current;
        const tooltipEl = tooltipRef.current;
        const rect = targetEl.getBoundingClientRect();
        const tooltipRect = tooltipEl.getBoundingClientRect();

        let top = 0;
        let left = 0;

        switch (position) {
            case "bottom":
                top = rect.bottom;
                left = rect.left + rect.width / 2 - tooltipRect.width / 2;
                break;
            case "top":
                top = rect.top - tooltipRect.height;
                left = rect.left + rect.width / 2 - tooltipRect.width / 2;
                break;
            case "left":
                top = rect.top + rect.height / 2 - tooltipRect.height / 2;
                left = rect.left - tooltipRect.width;
                break;
            case "right":
                top = rect.top + rect.height / 2 - tooltipRect.height / 2;
                left = rect.right;
                break;
        }

        setCoords({ top, left });
    }, [visible, position]);

    if (!visible || !content) return null;

    const { padding, textAlign, ...rootStyle } = style;
    const textStyle = { padding, textAlign, ...pt?.text?.style };

    return createPortal(
        <div
            ref={tooltipRef}
            className={`ui-tooltip ui-tooltip_${position}`}
            style={{
                ...rootStyle,
                top: `${coords.top}px`,
                left: `${coords.left}px`,
                pointerEvents: "none",
            }}
        >
            <div className="ui-tooltip__arrow" />
            <div className="ui-tooltip__text" style={textStyle}>
                {content}
            </div>
        </div>,
        document.body,
    );
};

export default Tooltip;
